import React from "react";

import { sidebarOnClicks} from "js/utilities/sdk-doc-utils";
import { Glyphicon } from "react-bootstrap";
import { Navigation, Link, History } from "react-router";
import SDKSidebar from "js/utilities/sdk-sidebar";

export default React.createClass({

  mixins: [Navigation],

  displayName: "Spoof Bounty Program",

  contextTypes: {
    router: React.PropTypes.object.isRequired
  },

  getInitialState() {
    return {
      error: ""
    };
  },

  componentDidMount: function() {
    sidebarOnClicks()
  },

  componentWillMount() {
  },


  render: function() {
      return (
        <div className="dash support">
          <div className="workspace">
            <div className="workspace__container">
              <section>
                <div className="title">
                  <Glyphicon glyph="user" />
                  <h2>Spoof Bounty Program</h2>
                </div>
                <p>Details about FaceTec's $100,000 Spoof Bounty Program.</p>
                <hr/>
              </section>
              <section>
                <iframe src="https://docs.google.com/document/d/1wQI5UcLq0Bip5S5a3zyH0719iUoiKDlRWqv5qMYS9Bc/preview" width="100%" height="100%"></iframe>
              </section>
              <SDKSidebar menuType="main" title="Spoof Bounty Program"/>
            </div>
          </div>
        </div>
        );
      },
    });



// WEBPACK FOOTER //
// ./src/js/components/screens/spoof-bounty-program.jsx